/* ================================================== */
/* PRELOAD
/* ================================================== */

$(window).load(function() {
	$('body').removeClass('preload');
	$(window).trigger('resize');
});